import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
    useTheme,
    Grid,
    Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FullLoader from "../../../components/Loader/FullLoader.component";
import PrimaryButtonUkoBeMyself from "../../../components/PrimaryButtonUkoBeMyself.component";
import { GenerateTokenOIDCAction } from "../../../actions/auth.action";
import { getVersionAppAction } from "../../../actions/applications.action";
import { isEmpty } from "../../../utils/proprietaryHooks";

const CallBack = (props) => {
    const {
        appName,
        tenant,
        GenerateTokenOIDC,
        loadingReducer,
        setTokenAuth,
        setErrorTokenAuth,
        getVersionAppAction,
        getVersionApp,
    } = props;

    const [error, setError] = useState(false);
    const [isTimeout, setIsTimeout] = useState(false);
    const [countdown, setCountdown] = useState(10);
    const [versionMessage, setVersionMessage] = useState("");
    const [uri, setUri] = useState("")
    const theme = useTheme();
    const classes = useStyles();
    const history = useHistory();
    const [t] = useTranslation("global");
    const getQueryParams = () => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (code) {
            GenerateTokenOIDC(code, tenant, appName);
        } else {
            setError(true);
        }

    };

    useEffect(() => {
        if (isTimeout) {
            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev === 1) {
                        clearInterval(timer);
                        window.location.assign(uri);
                    }
                    return prev - 1;
                });
            }, 1000);
    
            return () => clearInterval(timer);
        }
    }, [isTimeout, history, uri]);
    const formattedTime = `00:${countdown < 10 ? `0${countdown}` : countdown}`;
    /**
     * useefect load inicial componente CallBack
     */
    useEffect(() => {
        if (!isEmpty(getVersionApp)) {
            setVersionMessage(getVersionApp.version);
        }
    }, [getVersionApp]);

    useEffect(() => {
        getVersionAppAction(appName, tenant);
        getQueryParams();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (setTokenAuth) {
            if (setTokenAuth.response && setTokenAuth.statusCode === 200 && setTokenAuth.response.informationCode === 'A10') {
                window.location.assign(setTokenAuth.response.urlApp);
            }
        }
    }, [setTokenAuth]);

    useEffect(() => {
        if (setErrorTokenAuth) {
            setUri(setErrorTokenAuth.uri)
            if(setErrorTokenAuth.statusMessage){
                setIsTimeout(true);
            }
            if (setErrorTokenAuth.message) {
                setError(true);
            }
        }
    }, [setErrorTokenAuth, setTokenAuth]);

    const handleBackLogin = () => {
        window.location.assign(uri)
    };
    
    return (
        <>
            <Grid container style={{ minHeight: "93vh" }}>
                <Grid item md={12} xs={12} style={{ background: theme.palette.secondary.light, display: "flex", justifyContent: "center" }}>
                    <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                        {
                            error && (
                                <>
                                    <Box style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "98%" }} >
                                        <Box style={{ textAlign: "center", maxWidth: "550px", width: "100%", padding: "32px" }}>
                                            <Box style={{ marginBottom: '70px' }}>
                                                <img src={`/${theme.urlLogo.urlSignIn}`} alt="Logo" style={{ width: theme.widthImageLogo }} />
                                            </Box>
                                            <Box style={{ marginBottom: '70px' }}>
                                                <img src={`/${theme.logoErrorCallback}`} alt="ErrorCallback" style={{ width: "184px" }} />
                                            </Box>
                                            <Box>
                                                <h1 style={{ fontWeight: "700", fontStyle: 'normal', fontSize: "24px", marginTop: "20px", color: theme.palette.secondary.titleText }}>
                                                    {t("error-callback.title")}
                                                </h1>
                                            </Box>
                                            {isTimeout ? (
                                                <Box style={{ marginBottom: '70px' }}>
                                                    <h1 style={{ fontWeight: "400", fontStyle: 'normal', fontSize: "18px", marginTop: "20px", color: theme.palette.secondary.titleText }}>
                                                        {t("error-callback-application.description")}
                                                        <span style={{ color: "#E1FF2B", textDecoration: "underline" }}> {formattedTime}</span>
                                                    </h1>
                                                </Box>
                                            ):(
                                                <Box style={{ marginBottom: '70px' }}>
                                                    <h1 style={{ fontWeight: "400", fontStyle: 'normal', fontSize: "18px", marginTop: "20px", color: theme.palette.secondary.titleText }}>
                                                        {t("error-callback.description")}
                                                    </h1>
                                                </Box>
                                            )}
                                            
                                            <Box style={{ paddingRight: '88px', paddingLeft: '88px' }}>
                                                <PrimaryButtonUkoBeMyself
                                                    txtBtn={t("error-callback.button")}
                                                    disabled={false}
                                                    onClick={handleBackLogin}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box className={classes.version}>
                                        <p>{versionMessage}</p>
                                    </Box>
                                </>
                            )
                        }
                    </Box>
                </Grid>
            </Grid>

            <FullLoader open={loadingReducer.loading} />
        </>
    )
};

const useStyles = makeStyles((theme) => ({
    version: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.versionUko.colorVersionLabel,
        padding: '16px'
    },
}));

CallBack.propTypes = {
};

const mapStateToProps = (state) => ({
    getVersionApp: state.applicationsReducer.getVersionApp,
    loadingReducer: state.loadingReducer,
    setTokenAuth: state.authReducer.setTokenAuth,
    setErrorTokenAuth: state.authReducer.setErrorTokenAuth,
});

const mapDispatchToProps = {
    GenerateTokenOIDC: GenerateTokenOIDCAction,
    getVersionAppAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallBack);

